<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      v-if="isLoading"
      @dataAvailable="
        data => {
          if (!data?.metaData?.withdrawals) return
          totalPages = Math.ceil(data?.metaData?.total / 10)
          transactions = data?.metaData?.withdrawals
          this.isLoading = false
        }
      "
      :searchQuery="{ page: currentPage, limit: 10 }"
      contentId="withdrawalsByMomo"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Tranferts</div>
    </div>
    <div class="py-4"></div>

    <div v-if="isLoading || transactions.length > 0">
      <div class="py-4"></div>
      <div class="relative">
        <div class="w-full overflow-auto">
          <div>
            <div
              class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
            >
              <div class="flex items-center gap-4 w-[15rem] min-w-[15rem]">
                Nom du compte
              </div>

              <div class="flex gap-6 w-[12rem] min-w-[12rem]">Montant</div>
              <div class="flex gap-6 w-[8rem] min-w-[8rem]">Numéro</div>

              <div class="flex gap-6 w-[10rem] min-w-[10rem]">
                Pays / Opérateur
              </div>

              <div class="flex gap-6 w-[10rem] min-w-[10rem]">Date & Heure</div>

              <!-- Price and Quantity -->
              <div
                class="flex gap-6 w-[8rem] min-w-[8rem] justify-center text-center pr-4"
              >
                Status
              </div>
              <!-- <div
                  class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
                >
                  Actions
                </div> -->
            </div>
          </div>
          <div class="flex flex-col gap-4">
            <div
              v-for="(withdrawal, index) in isLoading
                ? shimmerAccounts
                : transactions"
              :key="index"
              class="flex items-center justify-between min-w-max p-4 rounded-2xl gap-8 [&>div]:relative"
              :class="{ shimmerElement: withdrawal.shimmer }"
            >
              <div
                class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
              ></div>
              <!-- Account Info -->
              <div class="flex items-center gap-4 w-[15rem] min-w-[15rem]">
                <img
                  :src="withdrawal.withdrawalAccount?.image"
                  :class="{
                    'opacity-0': !withdrawal.withdrawalAccount?.image,
                  }"
                  class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
                />
                <div class="w-[11rem]">
                  <h3 class="font-semibold title-color">
                    {{ withdrawal.withdrawalAccount?.fullName }}
                  </h3>
                </div>
              </div>

              <!-- Price and Quantity -->
                           <!-- Price and Quantity -->
                           <div class=" gap-6 w-[12rem] min-w-[12rem] ">
                <div>Demandé : <span class="title-color"> {{ withdrawal.amount }}&nbsp;FCFA</span></div>
                <div>Prélevé : <span class="title-color"> {{ withdrawal.amountToCollect }}&nbsp;FCFA</span></div>
                <div>Déposé : <span class="title-color"> {{ withdrawal.amountToDeposit }}&nbsp;FCFA</span></div>
              </div>
              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                <div>
                  {{ withdrawal.withdrawalAccount?.metadata?.accountId }}
                </div>
              </div>

              <!-- Price and Quantity -->
              <div class="w-[10rem] min-w-[10rem]">
                {{
                  this.$Countries.find(
                    withdrawal.withdrawalAccount?.countryCode,
                  )?.countryName
                }}
                /
                {{ withdrawal.withdrawalAccount?.metadata?.operator }}
              </div>

              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[10rem] min-w-[10rem]">
                {{
                  withdrawal.date
                    ? $Commons.timestampToDate(
                        withdrawal.date,
                        'DD MMM YYYY hh[h] mm',
                      )
                    : '-'
                }}
              </div>

              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[8rem] min-w-[8rem] justify-center pr-4">
                <button
                  class="whitespace-nowrap px-4 py-2 font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
                  :style="{
                    backgroundColor: statuses[withdrawal.status]?.background,
                    color: statuses[withdrawal.status]?.color,
                  }"
                >
                  {{ statuses[withdrawal.status]?.name }}
                </button>
              </div>

              <!-- SKU -->
              <!-- <div class=" text-gray-700">{{ account.sku }}</div> -->

              <!-- Actions -->
              <!-- <div
                  class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
                >
                  <DropdownComponent
                    :selects="[
                      {
                        name: 'Supprimer',
                        onClick() {
                          deleteAccount(withdrawal)
                        },
                      },
                    ]"
                    hideArrow
                    maxHeight="270px"
                    displayKey="name"
                    toLeft
                    :onSelect="
                      selected => {
                        selected.onClick()
                      }
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                      />
                    </svg>
                  </DropdownComponent>
                </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="py-2"></div>
      <div class="flex justify-center">
        <Pagination
          v-if="!isLoading"
          :currentPage="currentPage"
          :totalPages="totalPages"
          @pageClick="newPage => (currentPage = newPage)"
        />
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/5">
        <img src="@/assets/images/empty/exchange.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">
          Aucun transfert effectué
        </div>
        <div class="py-1"></div>
        <div class="text-lg">
          Utilisé le bouton détails des compte pour lancer un transfert
        </div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <button @click="activeTab = 'accounts'" class="buttonComponent">
            Comptes de transfert
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import Pagination from '../utils/Pagination.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    EventListener,
    Pagination,
  },
  data() {
    return {
      eventsIds: [],
      isLoading: true,
      totalPages: 0,
      currentPage: 1,
      transactions: [],
      shimmerAccounts: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],

      statuses: {
        pending: {
          id: 'pending',
          name: 'En attente',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paidWaiting: {
          id: 'pending',
          name: 'En cours',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        success: {
          id: 'success',
          name: 'Réussi',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        error: {
          id: 'error',
          name: 'Echoué',
          background: '#EEF2F3',
          color: '#696969',
        },
      },
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {},
  watch: {
    currentPage() {
      this.isLoading = true
    },
    activeStatus() {
      this.isLoading = true
      this.currentPage = 1
    },
  },
}
</script>
